import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "badge bg-primary px-1"
}
const _hoisted_2 = {
  class: "nav list-group list-group-flush ps-0",
  id: "Messages_List"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "ms-2 flex-grow-1" }
const _hoisted_6 = { class: "d-flex align-items-start" }
const _hoisted_7 = { class: "me-auto mb-1 flex-grow-1" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "d-flex align-items-center" }
const _hoisted_14 = {
  key: 0,
  class: "text-danger fw-bold pe-1 font-size-md"
}
const _hoisted_15 = {
  key: 1,
  class: "mx-1 text-danger"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation" }, null, -1 /* HOISTED */)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AvaInitials = _resolveComponent("AvaInitials")!
  const _component_Popover = _resolveComponent("Popover")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_link, {
      to: "/central-messaging/clinicians/conversation",
      class: _normalizeClass(`text-body ${_ctx.shakeMessageIcon ? 'shake-less' : ''}`),
      "data-bs-toggle": "collapse",
      "data-bs-target": "#App_Menu",
      onClick: _ctx.onUnreadMessages
    }, {
      default: _withCtx(() => [
        _createElementVNode("i", {
          class: _normalizeClass(["fab fa-facebook-messenger", [_ctx.isAxxessPlannerHeader ? 'text-white' : 'text-dark']]),
          title: "Unread Messages"
        }, null, 2 /* CLASS */),
        _createElementVNode("sup", null, [
          (_ctx.unreadConvIds?.length > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.unreadConvIds.length), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["class", "onClick"]),
    (_ctx.unreadConvIds.length > 0)
      ? (_openBlock(), _createBlock(_component_Popover, {
          key: 0,
          placement: "bottom-middle",
          className: "p-2 central-background"
        }, {
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAllUnreadConvs, (message) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: message.id,
                  class: "nav-item list-group-item message-list-item m-0",
                  onClick: ($event: any) => (_ctx.handleMenuSelection(message))
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_AvaInitials, {
                      classes: "me-1",
                      initialsType: message.conversationType,
                      user: message.users[0]
                    }, null, 8 /* PROPS */, ["initialsType", "user"]),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("h6", _hoisted_7, [
                          (message?.title?.length > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(message.title), 1 /* TEXT */))
                            : (message?.users?.length)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.formatDisplayUsers(message.users)), 1 /* TEXT */))
                              : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("small", _hoisted_10, _toDisplayString(_ctx.formatDateToLocalBasedOnDayMode(message.modifiedOn, true)), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", {
                          class: _normalizeClass(`${
                                    message.unread > 0 ? 'fw-semibold' : 'text-muted'
                                } me-auto flex-grow-1 align-self-start unread-text`),
                          innerHTML: _ctx.sanitizeMarkup(_ctx.markdownToHtml(message.text))
                        }, null, 10 /* CLASS, PROPS */, _hoisted_12),
                        _createElementVNode("div", _hoisted_13, [
                          (message?.isCurrentUserTagged)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "@"))
                            : _createCommentVNode("v-if", true),
                          (message.isImportant)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                            : _createCommentVNode("v-if", true),
                          _createElementVNode("b", {
                            class: _normalizeClass(`unread-count ${message.unread > 0 ? '' : 'd-none'}`)
                          }, _toDisplayString(message.unread), 3 /* TEXT, CLASS */)
                        ])
                      ])
                    ])
                  ])
                ], 8 /* PROPS */, _hoisted_3))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]),
          _: 1 /* STABLE */
        }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}